<div class="auth-login">
  <div class="auth-login-reset-password__content">

    <div class="auth-login__form auth-reset-password">
        <img [src]="companyInfo?.branding?.cache_icon_big || 'assets/images/logos/logo_placeholder.png'" />

      <h1 class="auth-login__form-title" [innerHTML]="'text_resetPasswordTitle' | dbText"></h1>

      <form (ngSubmit)="onResetPasswordSubmit()" [formGroup]="resetPasswordForm">
        <div class="auth-login__group general-error"
             *ngIf="serverErrors && serverErrors.message && !hasServerFieldErrors">
          <div class="db-server-error">{{serverErrors.message}}</div>
        </div>
        <div class="auth-login__group reset-password">
          <div class="db-form-group__input auth-login__group-password">
            <input class="ds-input-black" placeholder="New password" *ngIf="!showPassword" maxlength="128"
                   type="password" formControlName="password" name="password"
                   [style.border-color]="(resetPasswordForm.controls['password'].invalid && ((resetPasswordForm.controls['password'].touched && !resetPasswordForm.controls['password'].errors['required']) || formSubmitted)) ? '#E95E5B' : null"
                   (focus)="showPWDRequirements = true" (focusout)="showPWDRequirements = false"
                   (ngModelChange)="progressPercent()">
            <input class="ds-input-black" placeholder="New password" *ngIf="showPassword" maxlength="128" type="text"
                   formControlName="password" name="password"
                   [style.border-color]="(resetPasswordForm.controls['password'].invalid && ((resetPasswordForm.controls['password'].touched && !resetPasswordForm.controls['password'].errors['required']) || formSubmitted)) ? '#E95E5B' : null"
                   (focus)="showPWDRequirements = true" (focusout)="showPWDRequirements = false"
                   (ngModelChange)="progressPercent()">
            <i class="db-icon db-icon-eye" *ngIf="!showPassword" (click)="togglePassword()" title="Show password"></i>
            <i class="db-icon db-icon-eye-hide" *ngIf="showPassword" (click)="togglePassword()"
               title="Hide password"></i>
            <div *ngIf="(resetPasswordForm.controls['password'].invalid && ((resetPasswordForm.controls['password'].touched && !resetPasswordForm.controls['password'].errors['required']) || formSubmitted)) || hasServerFieldErrors">
              <div class="ds-input-error-msg">
                  <i class="db-icon db-icon-ds-notice"></i>
                  {{serverErrors?.fields?.password || ('text_invalidPassword1' | dbText)}}</div>
            </div>
            <db-password-validation [formGroup]="resetPasswordForm" *ngIf="showPWDRequirements"></db-password-validation>
            </div>
          </div>

        <div class="auth-login__group reset-password">
          <div class="db-form-group__input auth-login__group-password">
            <input class="ds-input-black" placeholder="Confirm new password" *ngIf="!showConfirmPassword"
                   maxlength="128" type="password" formControlName="confirmPassword" name="confirmPassword"
                   [style.border-color]="(resetPasswordForm.controls['confirmPassword'].invalid && ((resetPasswordForm.controls['confirmPassword'].touched && !resetPasswordForm.controls['confirmPassword'].errors['required']) || formSubmitted) ) ? '#E95E5B' : null">
            <input class="ds-input-black" placeholder="Confirm new password" *ngIf="showConfirmPassword" maxlength="128"
                   type="text" formControlName="confirmPassword" name="confirmPassword"
                   [style.border-color]="((resetPasswordForm?.controls?.password?.touched || resetPasswordForm?.controls?.confirmPassword?.touched) && !passwordsMatch) ? '#E95E5B' : null">
            <i class="db-icon db-icon-eye" *ngIf="!showConfirmPassword" (click)="toggleConfirmPassword()"
               title="Show password"></i>
            <i class="db-icon db-icon-eye-hide" *ngIf="showConfirmPassword" (click)="toggleConfirmPassword()"
               title="Hide password"></i>
            <div *ngIf="resetPasswordForm?.controls?.password?.touched && !passwordsMatch">
                <div class="ds-input-error-msg">
                    <i class="db-icon db-icon-ds-notice"></i>
                    {{'text_resetPasswordPasswordNotMatch' | dbText}}
                </div>
            </div>
          </div>
        </div>

        <div class="db-login-button-wrap">
          <button class="ds-btn-black ds-btn-max m" type="submit" [ngClass]="{'ds-btn-disabled': !passwordsMatch}">
            <span [innerHTML]="'text_forgotPasswordSubmit' | dbText | lowerCaseSpecificWords"></span>
          </button>
        </div>

      </form>
      <!--<div class="auth-login__footer">
        <div>{{'text_loginDontHaveAccount' | dbText}}</div>
        <div><a class="db-link" [routerLink]="['/sign-up/']" [queryParams]="{'subscr_id': 211}" >{{'text_loginCreateAccount' | dbText}}</a></div>
      </div>-->

    </div>
  </div>

  <db-loading-screen [ngClass]="{'hidden':!loading}"></db-loading-screen>
</div>
